import React, { useState } from "react";
import { DidomiSDK } from "@didomi/react";
import { useLanguage } from "../../AutobizTranslateProvider";
import { didomiSetConfig } from "../../language-context";

const Didomi = () => {
  const { language: currentLanguage } = useLanguage();
  const [didomiObject, setDidomiObject] = useState({});

  const didomiConfig = didomiSetConfig(currentLanguage);
  const onDidomiReady = (didomi: any) => {
    setDidomiObject(didomi);
  };
  return (
    <DidomiSDK
      apiKey={didomiConfig.apiKey}
      noticeId={didomiConfig.noticeId}
      config={didomiConfig.config}
      onReady={onDidomiReady}
    />
  );
};
export default Didomi;
